
import Layout from '@/layout/index.vue';
import type { RouteRecordRaw } from 'vue-router'
import { roterPre } from '@/setting';
const activityRouter: RouteRecordRaw =
{
  path: `${roterPre}/activity`,
  name: 'activity',
  meta: {
    icon: 's-ticket',
    title: '活动管理'
  },
  alwaysShow: true,
  component: Layout,
  children: [
    {
      path: 'classify',
      name: 'activityClassify',
      meta: {
        title: '活动分类',
        noCache: true
      },
      component: () => import('@/views/_expand/activity/activityClassify/index.vue')
    },
    {
      path: 'label',
      name: 'activityLabel',
      meta: {
        title: '活动标签',
        noCache: true
      },
      component: () => import('@/views/_expand/activity/activityLabel/index.vue')
    },
    {
      path: 'place/classify',
      name: 'activityPlaceClassify',
      meta: {
        title: '场地分类',
        noCache: true
      },
      component: () => import('@/views/_expand/activity/placeClassify/index.vue')
    },
    {
      path: 'list',
      name: 'activityList',
      meta: {
        title: '活动列表',
        noCache: true
      },
      component: () => import('@/views/_expand/activity/activityExamine/index.vue')
    },
      {
          path: 'place/capability',
          name: 'activityPlaceCapability',
          meta: {
              title: '场地能力档案',
              noCache: true
          },
          component: () => import('@/views/_expand/activity/placeCapability/index.vue')
      },
      {
          path: 'place',
          name: 'activityPlace',
          meta: {
              title: '公共场地库',
              noCache: true
          },
          component: () => import('@/views/_expand/activity/place/index.vue')
      },
      {
          path: 'place/edit',
          name: 'activityPlaceEdit',
          meta: {
              title: '编辑场地',
              noCache: true,
              activeMenu: `${roterPre}/activity/place`,
          },
          hidden: true,
          component: () => import('@/views/_expand/activity/place/edit.vue')
      },
      {
          path: 'questionnaire',
          name: 'activityQuestionnaire',
          meta: {
              title: '问卷',
              noCache: true
          },
          component: () => import('@/views/_expand/activity/questionnaire/index.vue')
      },

  ]
}

export default activityRouter;
